













































import Vue from 'vue'
import Folder from '../Folder'
import './FolderTree.scss'
import { Tree } from 'element-ui'
import { AssetGroup, AssetGroupType } from '@/types/assets'
import { sortBy } from 'lodash'
import { FolderTreeItem } from '@/components/FileExplorer/FolderList/FolderTree/FolderTree.model'
import { Drop } from 'vue-drag-drop'
import { KeyDict } from '@/types'
import { pickBy } from 'lodash'

  const RootFolderId = ''

  export default Vue.extend({
    name: 'FolderTree',
    props: {
      folders: {
        type: Object as () => KeyDict<AssetGroup>
      },
      selectedFolder: {
        type: String
      },
      inCast: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      hideFolderTree: false,
      folderTree: [] as FolderTreeItem[],
      defaultExpanded: [RootFolderId] as string[],
      canDropType: false,
      dragover: false,
      allAssets: {
        name: 'All assets',
        id: 'all'
      },
      liveStreamFolder: {
        id: AssetGroupType.LiveStream,
        name: 'Live Streams',
        type: AssetGroupType.LiveStream
      }
    }),
    created () {
      this.buildTree()
    },
    mounted () {
      console.log('folder tree mounted')
      if (this.selectedFolder) {
        this.selectFolder(this.selectedFolder)
      }
    },
    watch: {
      folders (_newVal: AssetGroup[]) {
        this.buildTree()
      },
      selectedFolder (newValue: string) {
        this.selectFolder(newValue)
      }
    },
    computed: {
      allfolders (): KeyDict<AssetGroup> {
        return this.$store.direct.state.assets.folderList
      },
    },
    methods: {
      // loadNode (node: any, resolve: any) {
      //   console.log('Request tree items for folder ', node.level)
      //   console.log('Request tree items for folder ', node.data.id)
      //   if (node.level === 0) {
      //     resolve(this.folderTree)
      //     return
      //   }
      //
      //   const folder = node.data
      //   const subfolders = this._addTreeItems(folder, this._asTreeItem(folder))
      //   console.log('subfolders ',subfolders)
      //   resolve(subfolders)
      // },
      handleDrop (data: any, _event: Event) {
        // console.log('FOLDERTREE handleDrop ', arguments)
        const folder: AssetGroup = data.folder
        if (!folder) {
          return
        }

        this.dragover = false
        this.folderAdded(folder)
      },
      handleDragover (data: any, event: any) {
        this.dragover = false
        if (!data) {
          return
        }

        // console.log('FOLDERTREE handleDragover ', data, event)
        const draggingFolder: AssetGroup = data.folder
        const alreadyInRoot = draggingFolder && !draggingFolder.parent_id

        if (!draggingFolder || alreadyInRoot) {
          this.canDropType = false
          event.dataTransfer.dropEffect = 'none'
          return
        }

        // console.log('DRAGGING FOLDER');
        event.dataTransfer.dropEffect = 'move'
        this.dragover = true
        this.canDropType = true

      },
      folderAdded (folder: AssetGroup): void {
        const alreadyInRoot = folder && !folder.parent_id
        if (alreadyInRoot) {
          // avoid dropping a folder onto itself by accident
          return
        }

        const folderProperties: Partial<AssetGroup> = {
          id: folder.id,
          parent_id: RootFolderId
        }
        this.$store.direct.dispatch.assets.updateAssetGroup(folderProperties)
          .then(() => {

            if (this.inCast) {
              // register this folder if you're in a cast:
              const updatedRootFolders = this.folders
              updatedRootFolders[folder.id] = folder
              const assetGroups = {} as {[ folderId: string]: boolean }
              Object.keys(updatedRootFolders).forEach(id => {
                assetGroups[id] = true
              })
              this.$store.direct.dispatch.events.updateCastAssetGroups(assetGroups)
            }

            this.$message({
              type: 'success',
              message: `${folder.name} has been moved to top level`
            })
          }).catch(error => {
          console.error('folderDrop error', error)
        })

      },
      assetDragged () {
        console.log('assetDragged ', arguments)
      },
      openFolder (folder) {
        const id = (folder.id !== '') ? folder.id : RootFolderId
        this.$emit('openFolder', id)
      },
      deleteFolder (folder) {
        this.$emit('deleteFolder', folder)
      },
      unlinkFolder (folder) {
        this.$emit('unlinkFolder', folder)
      },
      showFolderImport () {
        this.$emit('showFolderImport')
      },
      buildTree (): void {
        const treeItems: FolderTreeItem[] = []

        // Live stream folder is deprecated in assets
        // if (this.inCast) {
        //   treeItems.push(this._asTreeItem(this.liveStreamFolder))
        // }

        if (!!this.folders) {
          const rootFolders = pickBy(this.folders, f => !f.parent_id)
          sortBy(rootFolders, [o => o.name.toLowerCase()]).forEach((folder) => {
            const item: FolderTreeItem = this._addTreeItems(folder, this._asTreeItem(folder))
            treeItems.push(item)
          })
        }
        this.folderTree = this._attachToRootFolder(treeItems) // = with visible virtual root folder
        // this.folderTree = treeItems // = without visible virtual root folder
      },
      _addTreeItems (folder: AssetGroup, result: FolderTreeItem): FolderTreeItem {
        const folderId = folder.id || RootFolderId
        if (!folderId) {
          return result
        }

        const childFolders = Object.values(this.allfolders).filter(f => f.parent_id === folderId)
        sortBy(childFolders, [o => o.name.toLowerCase()]).forEach((childFolder: AssetGroup) => {
          if (childFolder.deleted) return
          const item = this._asTreeItem(childFolder)
          result.children!.push(this._addTreeItems(childFolder, item))
        })

        return result
      },
      _asTreeItem (folder: AssetGroup): FolderTreeItem {
        return {
          id: folder.id,
          label: folder.name,
          data: folder, // = reference to folder object (!)
          children: []
        } as FolderTreeItem
      },
      _attachToRootFolder (childFolders: FolderTreeItem[]): FolderTreeItem[] {
        // create a virtual assetgroup to hold the root folder
        const rootFolder: AssetGroup = {
          id: RootFolderId,
          type: AssetGroupType.Folder,
          deleted: false,
          name: 'All assets',
          team_id: '', // is it ok to leave this empty? should never be saved to db
          parent_id: RootFolderId,
          timestamp: new Date().getTime()
        }
        const rootFolderTreeItem = this._asTreeItem(rootFolder)
        rootFolderTreeItem.children = childFolders
        return [rootFolderTreeItem]
      },
      selectFolder (folderId) {
        const tree = this.$refs.tree as any
        if (tree) {
          this.defaultExpanded = [folderId]
        }
      }
    },
    components: {
      Folder,
      'el-tree': Tree,
      Drop
    }
  })
